import RestClient from '../RestClient/RestClient';
import { apiHosts } from '../RestClient/FetchHelper.config';

export const getCustomOptions = (payload) => {
    const context = RestClient.getContext();
    const config = {
        apiHost: apiHosts.browse,
        url: payload.url,
        excludeVersion: true,
        hostname: context && context.hostname,
        XForwardedChannelHeader: `${payload.deviceSize}`, // todo this
    };
    return RestClient.get(config)
        .then((json) => json.data)
        .catch((error) => {
            console.log(`request failed ${error}`);
        });
};
